import { render, staticRenderFns } from "./BookingNotificationModel.vue?vue&type=template&id=6874db92"
import script from "./BookingNotificationModel.vue?vue&type=script&lang=js"
export * from "./BookingNotificationModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports